import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromCharitableContribution from './charitable-contribution.reducers';

export interface CharitableContributionState {
  stateData: fromCharitableContribution.State;
}

export interface State extends fromRoot.AppState {
  charitableContribution: CharitableContributionState;
}

export const reducers = {
  stateData: fromCharitableContribution.reducer
};

export const selectCharitableContributionState = createFeatureSelector<CharitableContributionState>('charitableContribution');

export const selectCharitableContributionStateData = createSelector(selectCharitableContributionState, (state: CharitableContributionState) => state.stateData);

export const getCharitableContributionState = createSelector(selectCharitableContributionStateData, fromCharitableContribution.getStateData);

export const getCharitableContributionScreenError = createSelector(selectCharitableContributionStateData, fromCharitableContribution.getError);

export const getCharitableContributionScreenPending = createSelector(selectCharitableContributionStateData, fromCharitableContribution.getPending);